exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.parameter-select[data-v-a72acbe6] {\n  margin-left: 4px;\n  cursor: pointer;\n  min-width: 16px;\n}\n.green-line[data-v-a72acbe6] .v-select__slot {\n  -webkit-box-shadow: 0 1px 0 0 #92cd1d;\n          box-shadow: 0 1px 0 0 #92cd1d;\n}\n.red-line[data-v-a72acbe6] .v-select__slot {\n  -webkit-box-shadow: 0 1px 0 0 #f44336;\n          box-shadow: 0 1px 0 0 #f44336;\n}\n.black-line[data-v-a72acbe6] .v-select__slot {\n  -webkit-box-shadow: 0 1px 0 0 #000000;\n          box-shadow: 0 1px 0 0 #000000;\n}\n", ""]);

// exports
